export default {"src":"/_next/static/media/login-logo.200970d7.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};